import { Shell } from '../components/Shell'
import { Sill } from '../components/ui'

/**
 * Nothing feeds this yet — no table, no events. The screen exists so the
 * bell in the topbar goes somewhere real instead of nowhere; wiring it up
 * to actual activity is a separate piece of work.
 */
export default function Notifications() {
  return (
    <Shell tabs back="/me" title="Profile">
      <div className="eyebrow">Notifications</div>
      <h2 className="q">Nothing yet.</h2>
      <p className="sub">When there's something worth telling you about, it'll show up here.</p>
      <Sill />
    </Shell>
  )
}
